import { CtaType } from '../../models/Content';

export enum CtaLoginAction {
    LoginStrong = 'loginStrong',
    LoginAny = 'loginAny',
}

export type CtaLoginActionValue = `${CtaLoginAction}`;

export const isCtaLoginAction = (action?: string): action is CtaLoginActionValue =>
    action === CtaLoginAction.LoginStrong || action === CtaLoginAction.LoginAny;

export type CtaData = {
    id: string;
    title: string;
    action?: CtaLoginAction;
    url?: string;
    target?: '_blank';
    rel?: string;
    image?: Image;
    referencedContent?: CtaType['fields']['referencedContent'];
};

export type Image = { src: string; alt: string; width?: number; height?: number };

export type ResponsiveImageGroup = {
    imageSm: Image;
    imageMd: Image;
    imageLg: Image;
    altText?: string;
};
